import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";

// to import local storage from redux persist
import storage from "redux-persist/lib/storage";

import bountiesReducer from "./bounties/bounties.reducer";
import competitionsReducer from "./competitions/competitions.reducer";
import directoryReducer from "./directory/directory.reducer";
import fixturesReducer from "./fixtures/fixtures.reducer";
import globalReducer from "./globals/global.reducer";
import homePageSliderReducer from "./homepageSlideData/slider.reducer";
import homePageDataReducer from "./homepagedata/data.reducer";
import notificationsReducer from "./notifications/notifications.reducer";
import pairingsReducer from "./pairings/pairings.reducer";
import transactionsReducer from "./transactions/transactions.reducer";
import userReducer from "./user/user.reducer";
import walletReducer from "./wallet/wallet.reducer";
import withdrawalsReducer from "./withdrawals/withdrawals.reducer";

const persistConfig = {
  key: "root",
  storage,
  //white list is for the particular store we wanna persist, here since we wanna persist our use store for now
  whitelist: ["user"],
};

const rootReducer = combineReducers({
  user: userReducer,
  directory: directoryReducer,
  global: globalReducer,
  homePageSlider: homePageSliderReducer,
  homePageData: homePageDataReducer,
  transactions: transactionsReducer,
  withdrawals: withdrawalsReducer,
  bounties: bountiesReducer,
  competitions: competitionsReducer,
  fixtures: fixturesReducer,
  pairings: pairingsReducer,
  wallet: walletReducer,
  notifications: notificationsReducer,
});

export default persistReducer(persistConfig, rootReducer);
